import React from "react";
import style from "./stylesheets/Onboarding.module.scss";
import Logo from "./Logo";
import SlashIcon from "../resources/slash.png";
import Input from "./Input";
import Button from "./Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { setUID } from "../helpers/localStorage";

const Onboarding = ({ onClickAction }) => {
    const [email, setEmail] = React.useState("");
    const [error, setError] = React.useState("");

    const handleOnClick = () => {
        const sanitized = email.trim().toLowerCase();
        if(!sanitized.endsWith("@yale.edu")) {
            setError("Please enter a valid Yale email address.");
            return;
        }
        setUID(sanitized);
        if(onClickAction) onClickAction();
    };

    return (
        <div id={style.onboarding_container}>
            <div id={style.onboarding}>
                <Logo />
                <p id={style.blurb}>
                    Hello engineer! This is your digital passport to everything <strong>Engineering&nbsp;Week&nbsp;2026</strong>.
                </p>
                <div id={style.slash_bullets}>
                    <div>
                        <img src={SlashIcon} alt="slash" />
                        <p>Attend events to fill out your passport</p>
                    </div>
                    <div>
                        <img src={SlashIcon} alt="slash" />
                        <p>Find hidden scavenger hunt items around campus</p>
                    </div>
                    <div>
                        <img src={SlashIcon} alt="slash" />
                        <p>Earn points to win exclusive Yale Engineering swag</p>
                    </div>
                </div>
                <div id={style.cta}>
                    <Input
                        placeholder="first.last@yale.edu"
                        onChange={(e) => setEmail(e.target.value)}
                        value={email}
                        type="email"
                    />
                    <Button
                        secondary
                        text={(
                            <>
                                Let's go
                                <FontAwesomeIcon icon={faArrowRight} />
                            </>
                        )}
                        onClick={handleOnClick}
                    />
                </div>
                {error && <p id={style.error}>{error}</p>}
            </div>
        </div>
    );
};

export default Onboarding;
